"use client";

import type { ComponentProps, MouseEvent, ReactNode } from "react";
import { openSignInModal } from "@/lib/auth/sign-in-modal-store";

function preloadSignInModal(): void {
  void import("./sign-in-modal");
}

function isPlainClick(event: MouseEvent<HTMLAnchorElement>): boolean {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

export function SignInLink({
  href,
  children,
  ...anchorProps
}: Omit<ComponentProps<"a">, "href" | "onClick"> & {
  href: "/sign-in" | "/sign-up";
  children: ReactNode;
}) {
  return (
    <a
      {...anchorProps}
      href={href}
      onPointerEnter={preloadSignInModal}
      onFocus={preloadSignInModal}
      onTouchStart={preloadSignInModal}
      onClick={(event) => {
        if (!isPlainClick(event)) return;
        event.preventDefault();
        openSignInModal({ view: "start", purpose: href === "/sign-up" ? "sign-up" : "log-in" });
      }}
    >
      {children}
    </a>
  );
}
